import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {

    const location = useLocation();
  
    const isActive = (path) => {
      if (path === '/') {
        return location.pathname === '/' || location.pathname === '/home';
      }
      // Make 'Projects' active for any /projects* route
      if (path === '/projects') {
        return location.pathname === '/projects' || location.pathname.startsWith('/projects');
      }
      return location.pathname === path;
    };
  
    const navItems = [
      { path: '/', label: 'Home' },
      { path: '/projects', label: 'Projects' },
      { path: '/about', label: 'About' },
    ];

  return (
    <nav className="flex items-center justify-center bg-black p-2 mx-auto mt-6 mb-3 rounded-lg max-w-fit">
      {navItems.map(({ path, label }) => (
        <Link
          key={path}
          to={path}
          className={`px-4 py-2 text-sm no-underline transition-colors duration-300 
            ${isActive(path)
              ? 'text-green-300'
              : 'text-gray-400 hover:text-white'
            }`}
        >
          {label}
        </Link>
      ))}
    </nav>
  );
}

export default Navbar;